import { Link, createFileRoute } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"

import { IddZertifikat } from "@/components/idd/idd-zertifikat"
import { LoadState } from "@/components/load-state"
import { PrintButton } from "@/components/print-button"
import { Button } from "@/components/ui/button"
import { useDruckenSobald } from "@/lib/idd/drucken"
import { useIddNachweise } from "@/lib/idd-queries"

function AlleZertifikatePage() {
  const { data, isError, refetch } = useIddNachweise()
  useDruckenSobald(Boolean(data?.length))
  return (
    <div className="space-y-5">
      <div className="no-print flex flex-wrap items-center justify-between gap-2">
        <Button asChild variant="ghost" size="sm" className="-ml-2">
          <Link to="/idd/zertifikate">
            <ArrowLeft className="h-4 w-4" aria-hidden />
            Zertifikate
          </Link>
        </Button>
        {data && data.length > 0 && <PrintButton />}
      </div>
      {!data ? (
        <LoadState failed={isError} onRetry={() => void refetch()}>
          Deine Zertifikate konnten nicht geladen werden.
        </LoadState>
      ) : data.length === 0 ? (
        <p className="text-[14px] text-muted-foreground">Noch keine Zertifikate.</p>
      ) : (
        <div className="space-y-8 print:space-y-0">
          {data.map((n) => (
            <IddZertifikat key={n.id} nachweis={n} className="break-after-page" />
          ))}
        </div>
      )}
    </div>
  )
}

export const Route = createFileRoute("/_app/idd/zertifikate/alle")({
  component: AlleZertifikatePage,
})
